import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import App from './components/app/App';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import {config} from "./configs/config-firebase";

Sentry.init({
    dsn: "https://a2a80b02e4284eb49fbd7875bb45f0fc@o400167.ingest.sentry.io/5258341",
    environment: config.projectId
});

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx